import { Colors } from '@back-office/core';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import React from 'react';
import styled from 'styled-components';

export enum RecurringStatus {
  upload_processing = 'upload_processing',
  rejected = 'upload rejected',
  failed_to_upload = 'failed to upload',
  pending = 'pending approval',
  partial = 'partial approved',
  failed_to_approve = 'failed to approve',
  in_queue = 'in queue',
  ongoing = 'ongoing processing',
  failed = 'processing failed',
  completed = 'processing completed',
}

interface GcpRecurringStatusProps extends AvatarProps {
  size?: number;
  status?: RecurringStatus;
}

function chooseStatusColor(status: RecurringStatus): keyof Colors {
  switch (status) {
    case RecurringStatus.ongoing:
    case RecurringStatus.completed:
      return 'eucalyptus';
    case RecurringStatus.rejected:
    case RecurringStatus.failed_to_upload:
    case RecurringStatus.failed_to_approve:
    case RecurringStatus.failed:
      return 'redOrange';
    case RecurringStatus.partial:
    case RecurringStatus.in_queue:
      return 'goldenrod';
    default:
      return 'silver';
  }
}

const getSize = (size: number): string => {
  if (size) {
    return `${size}px`;
  }
  return '1rem';
};

export const GcpRecurringStatus = styled(
  ({ size, status, ...rest }: GcpRecurringStatusProps) => (
    <Avatar {...rest}>&nbsp;</Avatar>
  )
)<GcpRecurringStatusProps>`
  ${(props): string =>
    props?.status &&
    `background-color: ${
      props.theme.palette?.common[chooseStatusColor(props.status)]
    }`};
  height: ${(props) => getSize(props.size)}};
  width: ${(props) => getSize(props.size)}};
`;

export default GcpRecurringStatus;
